import React from 'react';
import { portfolioData } from '../mockData';

const Hero = () => {
  const { personal } = portfolioData;

  return (
    <section id="hero">
      <div className="hero-layout reveal">
        <div>
          <p className="hero-role">
            {personal.role} &nbsp;·&nbsp; {personal.affiliation} &nbsp;·&nbsp; {personal.institution}
          </p>
          <h1 className="hero-name">{personal.name}</h1>
          <p className="hero-bio">{personal.bio}</p>
          <div className="hero-links">
            <a href={`mailto:${personal.email}`} className="primary">Email</a>
            <a href={personal.github} target="_blank" rel="noopener noreferrer">GitHub</a>
            <a href={personal.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
